import AbstractManageable          from "./abstract-manageable"
import User                        from "./user"
import RateVariation               from "./rate-variation"
import InterestVariation           from "./interest-variation"
import ReimboursedCapitalVariation from "./reimboursed-capital-variation"

export default class Loan extends AbstractManageable {

	/**
	 * @param {Number}                        id 
	 * @param {String}                        number 
	 * @param {String}                        subject 
	 * @param {String}                        bank 
	 * @param {Number}                        amount 
	 * @param {Number}                        rate 
	 * @param {Number}                        duration 
	 * @param {Date}                          contractedOn 
	 * @param {Number}                        periodicity 
	 * @param {Boolean}                       constantAmortization 
	 * @param {Boolean}                       variableRate 
	 * @param {RateVariation[]}               rateVariations
	 * @param {InterestVariation[]}           interestVariations
	 * @param {ReimboursedCapitalVariation[]} reimboursedCapitalVariations
	 * @param {User}                          creator 
	 * @param {Date}                          createdAt 
	 * @param {User}                          updater 
	 * @param {Date}                          updatedAt 
	 */
	constructor(
			id,
			number,
			subject,
			bank,
			amount,
			rate,
			duration,
			contractedOn,
			periodicity,
			constantAmortization,
			variableRate,
			rateVariations,
			interestVariations,
			reimboursedCapitalVariations,
			creator, 
			createdAt, 
			updater, 
			updatedAt) {
		super(creator, createdAt, updater, updatedAt);

		this.constantAmortization         = constantAmortization;
		this.amount                       = amount;
		this.bank                         = bank;
		this.contractedOn                 = contractedOn;
		this.duration                     = duration;
		this.variableRate                 = variableRate;
		this.id                           = id;
		this.number                       = number;
		this.subject                      = subject;
		this.periodicity                  = periodicity;
		this.rate                         = rate;
		this.rateVariations               = rateVariations || [];
		this.interestVariations           = interestVariations || [];
		this.reimboursedCapitalVariations = reimboursedCapitalVariations || [];

		// decomposition
		this.interests            = []
		this.paymentAmounts       = []
		this.paymentDates         = []
		this.periodicRates        = []
		this.reimboursedCapitals  = []
		this.remainingCapitals    = []
	}

	static createFromJson = (json) => {
		if (!json) return null;

		return new Loan(
			json.id,
			json.number,
			json.subject,
			json.bank,
			json.amount,
			json.rate,
			json.duration,
			json.contractedOn ? new Date(json.contractedOn) : null,
			json.periodicity,
			json.constantAmortization,
			json.variableRate,
			json.rateVariations.map(rv => RateVariation.createFromJson(rv)),
			json.interestVariations.map(iv => InterestVariation.createFromJson(iv)),
			json.reimboursedCapitalVariations.map(rcv => ReimboursedCapitalVariation.createFromJson(rcv)),
			User.createFromJson(json.creator),
			json.createdAt ? new Date(json.createdAt) : null,
			User.createFromJson(json.updater),
			json.updatedAt ? new Date(json.updatedAt) : null
		);
	}
}


// WEBPACK FOOTER //
// ./src/model/loan.js